import React from 'react';

export const EmailLink: React.FC = () => {
    return <a href='mailto:flourishorfate@gmail.com'>FlourishOrFate@gmail.com</a>;
}